import { render, staticRenderFns } from "./treatrecordHome.vue?vue&type=template&id=104fd8cc"
import script from "./treatrecordHome.vue?vue&type=script&lang=js"
export * from "./treatrecordHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104fd8cc')) {
      api.createRecord('104fd8cc', component.options)
    } else {
      api.reload('104fd8cc', component.options)
    }
    module.hot.accept("./treatrecordHome.vue?vue&type=template&id=104fd8cc", function () {
      api.rerender('104fd8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/therapy/treatrecordHome.vue"
export default component.exports